import {addedWithinPeriod} from 'core/History';
import {periodOf} from 'core/Budget';

export function totalAdded(budget: Budget, history: HistoryLog): MoneyAmount {
  return addedWithinPeriod(history, periodOf(budget));
}
